import { autoinject } from "aurelia-framework";
import { OfferingModel } from "../../../../../../models/onboarding/onboarding.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { FileHelper } from "../../../../../../helpers/file-helper";

@autoinject
export class OfferingDetailsDialog {

    offering: OfferingModel;

    constructor(private dialogClientService: DialogClientService) { }

    public activate(offering: OfferingModel) {
        this.offering = offering;
    }

    downloadDocument(offering: OfferingModel) {
        FileHelper.downloadFile(`/api/v1/OnboardingClient/DownloadOfferingDocument/${offering.offeringId}/${offering.name}`);
        event.stopPropagation();
    }

    close() {
        this.dialogClientService.hide();
    }
}